import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Header.css';

const Header = ({ title, showBackButton = false }) => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate('/');
  };

  return (
    <div className="header">
      {showBackButton && (
        <button className="back-button" onClick={handleBackClick}>
          ← 返回首页
        </button>
      )}
      <div className="header-title">
        {title}
      </div>
    </div>
  );
};

export default Header; 